<template>
  <div id="burger" :class="{ 'active' : mobileMenuRef }" @click.prevent="toggle">
    <slot>
      <button type="button" class="burger-button" title="Menu">
        <span class="burger-bar burger-bar-1"></span>
        <span class="burger-bar burger-bar-2"></span>
        <span class="burger-bar burger-bar-3"></span>
      </button>
    </slot>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useUIStore } from '~/store/uiStore';

const uiStore = useUIStore();

// Accessing the mobileMenu state from uiStore
const mobileMenuRef = ref(uiStore.mobileMenu);

const toggle = () => {
  console.log("Toggling mobile menu");
  uiStore.setMobileMenu(!mobileMenuRef.value);
}
</script>

<style scoped lang="scss">
@import '~/assets/constants.scss';
.hidden {
  visibility: hidden;
}

button {
  cursor: pointer;

  &:focus {
    outline: 0;
  }
}

.burger-button {
  position: relative;
  height: 30px;
  width: 3rem;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover .burger-bar-2 {
    transform: scaleX(1);
  }
}

.burger-bar {
  background-color: $light-white;
  position: absolute;
  top: 50%;
  right: 0.6rem;
  left: 0.6rem;
  height: 0.2rem;
  width: auto;
  margin-top: 0;
  transition: 
    transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1), 
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1), 
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);

  &-1 {
    transform: translateY(-0.5rem);
  }

  &-2 {
    transform-origin: 100% 50%;
    transform: scaleX(0.8);
  }

  &-3 {
    transform: translateY(0.5rem);
  }
}

.no-touchevents {
  .burger-bar-2:hover {
    transform: scaleX(1);
  }
}

#burger {
  &.active {
    .burger-button {
      transform: rotate(-180deg);
    }

    .burger-bar {
      background-color: #fff;

      &-1 {
        transform: rotate(45deg);
      }

      &-2 {
        opacity: 0;
      }

      &-3 {
        transform: rotate(-45deg);
      }
    }
  }
}

</style>
